/**
 * @generated SignedSource<<72d378dada15e1485c812c552987bd22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type InHouseGameTableExitedSubscription$variables = {};
export type InHouseGameTableExitedSubscription$data = {
  readonly tableExited: {
    readonly uuid: string;
  };
};
export type InHouseGameTableExitedSubscription = {
  variables: InHouseGameTableExitedSubscription$variables;
  response: InHouseGameTableExitedSubscription$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TableExitedBody",
    "kind": "LinkedField",
    "name": "tableExited",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InHouseGameTableExitedSubscription",
    "selections": (v0/*: any*/),
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InHouseGameTableExitedSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "30fcc40da9acbbbf210ec0765f25a0ef",
    "id": null,
    "metadata": {},
    "name": "InHouseGameTableExitedSubscription",
    "operationKind": "subscription",
    "text": "subscription InHouseGameTableExitedSubscription {\n  tableExited {\n    uuid\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f389c05fadef12311a594dd2fa0aff0";

export default node;
